<template>
  <div>
    <v-dialog v-model="getRlDeleteDialog.show" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Entry</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="getRlDeleteDialog.alert.show" dense outlined :type="getRlDeleteDialog.alert.type" :icon="getRlDeleteDialog.alert.icon">{{ getRlDeleteDialog.alert.message }}</v-alert>
          <v-progress-linear :active="dialogLoading" height="3" indeterminate absolute color="primary" />
          <v-container>
            <v-row>
              <v-col cols="12">
                <span>The entry will be permanently removed!</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click.prevent="closeDialog()" :disabled="dialogLoading">Close</v-btn>
          <v-btn color="primary" @click.prevent="saveDialog()" :disabled="dialogLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
	data() {
		return {
      dialogLoading: false
		}
	},
	methods: {
    closeDialog() {
      this.setRlDeleteDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
    },
    async saveDialog() {     
			try {
				this.dialogLoading = true
				await axios.delete('api/v1/recyclingLedgerEntries/' + this.getRlEntry.id)
				this.dialogLoading = false 
        this.setRlDeleteDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
        this.setRlEntryList()
      } catch (error) {
        this.dialogLoading = false
        this.setRlDeleteDialog({show: true, alert: {show: true, type: "error", icon: "error", message: error.response.data.message}})
      }
    },
		...mapActions([
      'setRlDeleteDialog',
      'setRlEntryList'
		])
	},
	computed: {
    ...mapGetters([
      'getRlEntry',
			'getRlDeleteDialog'
		])
  }
}
</script>

